import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { Animations } from '@fi-shared/utils/animations';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { ISiteDesign } from '@fi-shared/models';
import { FiSiteDesignService } from '@fi-shared/fi-shared-services/fi-site-design.service';
import { FiSiteDesignHelperService } from '@fi-app/fi-site-design/fi-site-design-helper.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiSiteDesignBrandDeleteConfirmDialogComponent } from '@fi-app/fi-site-design/fi-site-design-settings/fi-site-design-brand-delete-confirm-dialog/fi-site-design-brand-delete-confirm-dialog.component';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

@Component({
    selector: 'fi-site-design-settings',
    templateUrl: './fi-site-design-settings.component.html',
    styleUrls: ['./fi-site-design-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: [Animations.enterState(200)],
    host: { class: 'fi-site-design-settings' },
    standalone: false,
})
export class FiSiteDesignSettingsComponent implements OnInit {
    @Input() siteDesigns: ISiteDesign[];

    constructor(
        private stateService: FiStateService,
        private customerDataService: FiCustomerDataService,
        private mediaStorageService: FiMediaStorageService,
        private fiSiteDesignService: FiSiteDesignService,
        private fiSiteDesignHelperService: FiSiteDesignHelperService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {}

    cloneSiteDesign(siteDesignId: number) {
        this.fiSiteDesignService.cloneSiteDesign(siteDesignId).then(() => this.getSiteDesigns());
    }

    setSiteDesignAsDefault(siteDesignId: number) {
        this.fiSiteDesignService.setDefaultSiteDesign(siteDesignId).then(() => this.getSiteDesigns());
    }

    openDeleteConfirmationDialog(siteDesignId: number) {
        this.fiDialogsService
            .custom({
                headerText: this.appTextService.get('site_design.delete_brand') + '?',
                yesButtonText: this.appTextService.get('site_design.delete_brand'),
                contentComponentRef: FiSiteDesignBrandDeleteConfirmDialogComponent,
                contentComponentData: {
                    siteDesignToDeleteId: siteDesignId,
                    allSiteDesigns: this.siteDesigns,
                },
            })
            .onYesButtonClick((result) =>
                this.deleteSiteDesign(result.siteDesignIdToDelete, result.successorSiteDesignId),
            );
    }

    private deleteSiteDesign(siteDesignIdToDelete: number, successorSiteDesignId: number) {
        this.fiSiteDesignService
            .deleteSiteDesign(siteDesignIdToDelete, successorSiteDesignId)
            .then(() => this.getSiteDesigns());
    }

    createNewSiteDesign() {
        const newSiteDesign = this.fiSiteDesignHelperService.getSiteDesignNewInstance();
        newSiteDesign.Name = this.appTextService.get('site_design.new_design');
        this.fiSiteDesignService.saveSiteDesign(newSiteDesign).then(() => this.getSiteDesigns());
    }

    private getSiteDesigns() {
        this.fiSiteDesignService.getSiteDesigns().then((result) => {
            this.siteDesigns = result;
            this.cdr.markForCheck();
        });
    }

    back() {
        window.history.back();
    }
}
